import styled from 'styled-components';
import { GatsbyImage } from "gatsby-plugin-image"

export const BookImg = styled(GatsbyImage)`
    width: 482px;
`;